import * as React from "react";
import clsx from "clsx"; // Import clsx

function Badge({ className, variant = "default", ...props }) {
  const badgeClasses = {
    default: "border-transparent bg-primary text-primary-foreground",
    secondary: "border-transparent bg-[#EDE9FE] text-[#5B21B6]",
    destructive: "border-transparent bg-destructive text-destructive-foreground",
    outline: "text-foreground",
    pending: "border-transparent bg-amber-100 text-amber-800",
    approved: "border-transparent bg-green-100 text-green-800",
    rejected: "border-transparent bg-red-100 text-red-800",
    clarification: "border-transparent bg-blue-100 text-blue-800",
    success: "border-transparent bg-green-100 text-green-800",
    active: "border-transparent bg-green-100 text-green-800",
    resolved: "border-transparent bg-green-100 text-green-800",
    inactive: "border-transparent bg-red-100 text-red-800",
    review: "border-transparent bg-[#DBEAFE] text-[#1E40AF]",
  };

  return (
    <div
      className={clsx(
        "inline-flex items-center rounded-sm px-2.5 py-1.5 text-xs font-normal transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
        badgeClasses[variant] || badgeClasses["secondary"], 
        className
      )}
      {...props}
    />
  );
}

export { Badge };
